import { types } from '../../types/types'

export const initialState = {
  medico: {},
  consultaMedico: null,
  profesionalEspecialidades: null,
  profesionalCentros: null,
  error: "",
  loading: false,
}

export const medicosAbmReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.abmMedicosSeleccionado:
      return {
        ...state,
        consultaMedico: action.payload,
      }
    case types.abmMedicosLimpiarSeleccion:
      return {
        ...state,
        consultaMedico: null,
      }
    case types.abmMedicosNuevoMedicoStep:
      return {
        ...state,
        medico: action.payload
      }
    case types.especialidadesProfesionalTraer:
      return {
        ...state,
        loading: true,
      };
    case types.especialidadesProfesionalTraerSucces:
      return {
        ...state,
        loading: false,
        profesionalEspecialidades: action.payload,
      };
    case types.especialidadesProfesionalTraerError:
      return {
        ...state,
        loading: false,
      };
    case types.centrosPropiosProfesionalTraer:
      return {
        ...state,
        loading: true,
      };
    case types.centrosPropiosProfesionalTraerSucces:
      return {
        ...state,
        loading: false,
        profesionalCentros: action.payload,
      };
    case types.centrosPropiosProfesionalTraerError:
      return {
        ...state,
        loading: false,
      };
    case types.setOrDeleteEspecialidadProfesional:
      return {
        ...state,
        loading: true,
      };
    case types.setOrDeleteEspecialidadProfesionalSuccess:
      return {
        ...state,
        loading: false,
        profesionalEspecialidades: action.payload,
      };
    case types.setOrDeleteEspecialidadProfesionalError:
      return {
        ...state,
        loading: false,
      };
    case types.setOrDeleteCMProfesional:
      return {
        ...state,
        loading: true,
      };
    case types.setOrDeleteCMProfesionalSuccess:
      return {
        ...state,
        loading: false,
        profesionalCentros: action.payload,
      };
    case types.setOrDeleteCMProfesionalError:
      return {
        ...state,
        loading: false,
      };
    case types.limpiarMedicosAbm:
      return {
        ...initialState
      };
    default: return state
  }
}